import { hasShowDetails } from 'utils/showDetails';

const getPriceByPlan = (
  beneficiaryPlan: any,
  simulatorSharePriceUnit: any,
  includeAllUnits: boolean
) => {
  const totalUnits = includeAllUnits
    ? beneficiaryPlan?.sharesCount?.future || 0
    : beneficiaryPlan?.vestedUnits || 0;

  const totalSalePrice = totalUnits * simulatorSharePriceUnit || 0;

  const totalInitialPrice =
    totalUnits *
    (beneficiaryPlan?.customConditions?.sharePrice ||
      beneficiaryPlan?.planData?.sharePrice);

  const totalPrice = totalSalePrice - totalInitialPrice;

  const finalPrice = totalPrice;

  if (hasShowDetails()) {
    console.log('cclog getPriceByPlan', {
      totalUnits,
      totalSalePrice,
      totalInitialPrice,
      totalPrice,
      finalPrice,
    });
  }

  return finalPrice;
};

export default getPriceByPlan;
